import { configureImageUploadComponents } from '../../components/image_upload_input'
import { toggleStateField } from '../../components/state'

function initBranchUpdate() {
  configureImageUploadComponents()

  const stateField = document.getElementById(
    'id_address-state',
  ) as HTMLSelectElement
  toggleStateField(stateField, 'id_address-state')
  stateField.addEventListener('change', function () {
    toggleStateField(stateField, 'id_address-state')
  })
}

export { initBranchUpdate }
